import { PREVIEW_IFRAME_ID } from "../core/constants";
import { useCallback } from "react";

export const useScrollTo = () => {
  const scrollToElement = useCallback(
    (element: Element | null, options?: ScrollIntoViewOptions) => {
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          ...options,
        });
      }
    },
    [],
  );

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
  }, []);

  const scrollToId = useCallback(
    (id: string, options?: ScrollIntoViewOptions) => {
      let element = document.querySelector(`#${id}`);

      // If not found, try to find in preview iframe
      if (!element) {
        const iframe = document.querySelector(
          `#${PREVIEW_IFRAME_ID}`,
        ) as HTMLIFrameElement;

        element = iframe?.contentDocument?.querySelector(`#${id}`) || null;
      }
      scrollToElement(element, options);
    },
    [scrollToElement],
  );

  return {
    scrollToElement,
    scrollToId,
    scrollToTop,
  };
};
